import React, { Component } from 'react';
import { ErrorMessage, Field, Form, Formik } from 'formik';
import CustomSelect from '../../../../common/formElements/CustomSelect';
import { dynamicSort } from '../../../../common/utils/api_utils';
import CustomSelectGroup from '../../../../common/formElements/CustomSelectGroup';
import {
  getTemplateCollectionFieldOptions,
  getProjectConstantOptions,
  getSessionOptions,
} from './SmsFieldsUtil';
import { pluginCode } from 'drapcode-constant';
import { getItemIdFromOptions } from '../../../../common/utils/event_constants';
import BrowserStorageLocationField from '../BrowserStorageLocationField';
import FormFieldWithLabel from '../../../common/FormFieldWithLabel';
import { validateItemIdBSLKey } from '../collection/Util';

export default class SmsTemplateForm extends Component {
  createSchemaForFields = () => {
    const {
      templateId,
      numberFields,
      smsServicePlugin,
      dltTemplateId,
      smsType,
      getItemIdFrom,
      browserStorageLocation,
      browserStorageItemIdPath,
      fromNumberField,
    } = this.props.smsTemplateRule;
    return {
      templateId: templateId || '',
      numberFields: numberFields || '',
      smsServicePlugin: smsServicePlugin || '',
      dltTemplateId: dltTemplateId || '',
      smsType: smsType || '',
      getItemIdFrom: getItemIdFrom || '',
      browserStorageLocation: browserStorageLocation || '',
      browserStorageItemIdPath: browserStorageItemIdPath || '',
      fromNumberField: fromNumberField || '',
    };
  };

  getSmsTemplateOptions = () => {
    let options = [{ value: '', label: '-Select One-' }];
    let templateOptions = this.props.smsTemplates
      .filter((item) => !item.parentTemplateId)
      .sort(dynamicSort('name'))
      .map((item, key) => ({ value: item.uuid, label: item.name }));
    return [...options, ...templateOptions];
  };

  getNumberFieldsOptions = (templateId) => {
    const { collections, smsTemplates, projectDetail } = this.props;
    const selectedTemplate = smsTemplates ? smsTemplates.find((e) => e.uuid === templateId) : null;
    const templateCollectionName = selectedTemplate ? selectedTemplate.collectionId : null;
    const templateCollection =
      collections && templateCollectionName
        ? collections.find((e) => e.collectionName === templateCollectionName)
        : null;
    let options = getTemplateCollectionFieldOptions(templateCollection, collections);
    let projectConstantOptions = getProjectConstantOptions(projectDetail);
    let sessionOptions = getSessionOptions(collections);
    let groupedOptions = [
      {
        label: 'Fields',
        options: options,
      },
      {
        label: 'Project Constant',
        options: projectConstantOptions,
      },
      {
        label: 'Current LoggedIn User',
        options: sessionOptions,
      },
    ];

    return groupedOptions;
  };

  getSmsServicePluginOptions = () => {
    const { installedPlugins } = this.props;
    const installedCodes = new Set(installedPlugins.map((p) => p.code));
    const providerMap = [
      { code: pluginCode.AWS_SNS, value: 'AWS_SNS', label: 'AWS SNS' },
      { code: pluginCode.TWILIO, value: 'TWILIO', label: 'Twilio' },
      { code: pluginCode.PARKEN, value: 'PARKEN', label: 'Parken' },
      {
        code: pluginCode.AFRICAS_TALKING_SMS,
        value: 'AFRICAS_TALKING_SMS',
        label: "Africa's Talking",
      },
      { code: pluginCode.HOSTPINNACLE, value: 'HOSTPINNACLE', label: 'HostPinnacle' },
      { code: pluginCode.TELNYX, value: 'TELNYX', label: 'Telnyx' },
    ];
    return [
      { value: '', label: '-Select One-' },
      ...providerMap
        .filter(({ code }) => installedCodes.has(code))
        .map(({ value, label }) => ({ value, label })),
    ];
  };

  handleSubmit = (values) => {
    this.props.handleSubmit(values);
  };

  closeAllOpenPopup = () => {
    this.props.closeAllOpenPopup();
  };

  render() {
    return (
      <Formik
        enableReinitialize={true}
        initialValues={this.createSchemaForFields()}
        onSubmit={(values, { setSubmitting, resetForm }) => {
          this.handleSubmit(values);
          setSubmitting(false);
          resetForm();
        }}
      >
        {({ isSubmitting, values, setFieldValue, setFieldTouched, errors }) => (
          <Form>
            <div className="row">
              <div className="col-12">
                <div className="form-group">
                  <label>{'SMS Template'}*</label>
                  <CustomSelect
                    name="templateId"
                    isMulti={false}
                    onChange={setFieldValue}
                    onBlur={setFieldTouched}
                    options={this.getSmsTemplateOptions()}
                    value={values['templateId']}
                  />
                  <ErrorMessage name={'templateId'}>
                    {(msg) => <p className="text-error">{msg}</p>}
                  </ErrorMessage>
                  <small>Select a template you want to send via this event.</small>
                </div>
                <div className="form-group">
                  <label>{'Phone Number Fields'}*</label>
                  <CustomSelectGroup
                    name="numberFields"
                    isMulti={true}
                    onChange={setFieldValue}
                    onBlur={setFieldTouched}
                    options={this.getNumberFieldsOptions(values['templateId'])}
                    value={values['numberFields']}
                  />
                  <ErrorMessage name={'page'}>
                    {(msg) => <p className="text-error">{msg}</p>}
                  </ErrorMessage>
                  <small>Select the phone number field.</small>
                </div>
                <div className="form-group">
                  <label>SMS Service Plugin*</label>
                  <CustomSelect
                    name="smsServicePlugin"
                    isMulti={false}
                    onChange={setFieldValue}
                    onBlur={setFieldTouched}
                    options={this.getSmsServicePluginOptions()}
                    value={values['smsServicePlugin']}
                  />
                  <ErrorMessage name="smsServicePlugin">
                    {(msg) => <p className="text-error">{msg}</p>}
                  </ErrorMessage>
                  <small>Select the service from which you want to send the SMS.</small>
                </div>
                {values['smsServicePlugin'] === 'PARKEN' && (
                  <>
                    <div className="form-group">
                      <label>DLT Template ID*</label>
                      <input
                        type="text"
                        name="dltTemplateId"
                        className="form-control"
                        value={values.dltTemplateId || ''}
                        onChange={(e) => setFieldValue('dltTemplateId', e.target.value)}
                        onBlur={() => setFieldTouched('dltTemplateId', true)}
                      />
                      <ErrorMessage name="dltTemplateId">
                        {(msg) => <p className="text-error">{msg}</p>}
                      </ErrorMessage>
                      <small>Enter the DLT-approved template ID.</small>
                    </div>

                    <div className="form-group">
                      <label>SMS Type*</label>
                      <CustomSelect
                        name="smsType"
                        isMulti={false}
                        onChange={setFieldValue}
                        onBlur={setFieldTouched}
                        options={[
                          { value: '', label: '-Select One-' },
                          { value: '1', label: 'Transactional' },
                          { value: '2', label: 'Sender ID' },
                          { value: '3', label: 'Promotional' },
                          { value: '4', label: 'Trans OTP' },
                          { value: '5', label: 'Promo Tran' },
                          { value: '6', label: 'SIMBASE' },
                          { value: '7', label: 'SIMBAS' },
                          { value: '9', label: 'SMBASE' },
                          { value: '10', label: 'Defaultsfac' },
                          { value: '11', label: 'BSNLTRA' },
                          { value: '12', label: 'International' },
                        ]}
                        value={values.smsType}
                      />
                      <ErrorMessage name="smsType">
                        {(msg) => <p className="text-error">{msg}</p>}
                      </ErrorMessage>
                      <small>Select the type of SMS you're sending.</small>
                    </div>
                  </>
                )}
                {values['smsServicePlugin'] === 'TELNYX' && (
                  <>
                    <div className="form-group">
                      <label>From Number Field*</label>
                      <CustomSelect
                        name="fromNumberField"
                        isMulti={false}
                        onChange={setFieldValue}
                        onBlur={setFieldTouched}
                        options={this.getNumberFieldsOptions(values['templateId'])}
                        value={values['fromNumberField']}
                      />
                      <ErrorMessage name="fromNumberField">
                        {(msg) => <p className="text-error">{msg}</p>}
                      </ErrorMessage>
                      <small>Select the From Number Field.</small>
                    </div>
                  </>
                )}
                <div className="form-group">
                  <label>Get Item Id From</label>
                  <CustomSelect
                    name="getItemIdFrom"
                    isMulti={false}
                    onChange={setFieldValue}
                    onBlur={setFieldTouched}
                    options={getItemIdFromOptions}
                    value={values['getItemIdFrom']}
                    onChangeValue={(name, value) => setFieldValue('getItemIdFrom', value)}
                  />
                </div>
                {values.getItemIdFrom === 'sendBSLItemId' && (
                  <>
                    <BrowserStorageLocationField
                      fieldName={'browserStorageLocation'}
                      values={values}
                      description={
                        'Select a browser storage location to get an Item ID key (Default: Session Storage).'
                      }
                      setFieldValue={setFieldValue}
                      setFieldTouched={setFieldTouched}
                    />
                    <div className="form-group">
                      <FormFieldWithLabel
                        cta={false}
                        label="Browser Storage Key"
                        icon="text"
                        infoIcon={true}
                        infoDescription={`Enter the key which contains Item ID value in your web browser storage.`}
                      >
                        <Field
                          type="text"
                          name="browserStorageItemIdPath"
                          className="form-control form-control-sm"
                          autoComplete="off"
                          placeholder="Item ID JSON Key Eg. Key1 or, Parent_Key1.Child_Key[0]"
                          validate={validateItemIdBSLKey}
                        />
                      </FormFieldWithLabel>
                      <ErrorMessage name={'browserStorageItemIdPath'}>
                        {(msg) => <p className="text-error ml-5">{msg}</p>}
                      </ErrorMessage>
                    </div>
                  </>
                )}
              </div>
            </div>
            {this.props.children}
          </Form>
        )}
      </Formik>
    );
  }
}
